import api from 'api'

export type ListingFunnelStep = {
  name: string
  eventType: string
  users: number
  conversionFromPrev: number | null
}

export type ListingFunnelResponse = {
  listingId: number
  startDate: string
  endDate: string
  dataRefreshedAt: string | null
  steps: ListingFunnelStep[]
}

export async function getListingFunnel(
  listingId: number,
  timeRange: { startDate: string; endDate: string }
) {
  const response = await api.get<ListingFunnelResponse>(
    `/admin/listing/${listingId}/funnel`,
    { params: timeRange }
  )
  return response.data
}
